import { useEffect, useState, useRef } from "react";

const PasscodePopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [enteredCode, setEnteredCode] = useState("");
  const correctPasscode = "2k000114";
  const timeoutRef = useRef(null);

  useEffect(() => {
    const lastPopupMonth = localStorage.getItem("popupShown"); // e.g. "2025-09"
    const now = new Date();

    const currentYearMonth = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}`;

    if (lastPopupMonth === currentYearMonth) {
      // Already passed this month, no popup
      return;
    }

    // Set target date to 1st of current month at 11:00 AM
    const targetDate = new Date(now.getFullYear(), now.getMonth(), 1, 11, 0, 0);

    const currentTime = now.getTime();
    const targetTime = targetDate.getTime();

    if (currentTime >= targetTime) {
      // If current time is past 1st of month 11:00 AM, show immediately
      setShowPopup(true);
    } else {
      // Otherwise, schedule popup for the 1st at 11:00 AM
      timeoutRef.current = setTimeout(() => {
        setShowPopup(true);
      }, targetTime - currentTime);
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handlePasscodeSubmit = () => {
    if (enteredCode === correctPasscode) {
      // Save the current year-month as the last shown month
      const now = new Date();
      const currentYearMonth = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}`;
      localStorage.setItem("popupShown", currentYearMonth);
      setShowPopup(false);
    } else {
      alert("Incorrect passcode. Try again!");
    }
  };

  return (
    <>
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 1)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              width: "35%",
              borderRadius: "5px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h5>
              For verification purposes, please enter a PIN code to continue
              using your software
            </h5>
            <h6>Contact 2K Virtual World</h6>
            <input
              type="text"
              placeholder="Enter Code"
              value={enteredCode}
              onChange={(e) => setEnteredCode(e.target.value)}
              style={styles.input}
              autoFocus
            />
            <button onClick={handlePasscodeSubmit} style={styles.button}>
              Submit
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  input: {
    display: "block",
    margin: "10px 0",
    padding: "5px",
    textAlign: "center",
  },
  button: {
    padding: "8px 12px",
    background: "#007bff",
    color: "white",
    border: "none",
    cursor: "pointer",
  },
};

export default PasscodePopup;
